import React from 'react';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

const ColoredNullValueComponent = () => <TextBodyMedium color="#333333">NA</TextBodyMedium>;

export default ColoredNullValueComponent;
